import VCheckbox from './VCheckbox'

/* istanbul ignore next */
VCheckbox.install = function install (Vue) {
  Vue.component(VCheckbox.name, VCheckbox)
}

export { VCheckbox }
export default VCheckbox
